<div class="text-lg font-bold flex flex-col xs:flex-col sm:flex-row justify-between items-center px-3 mt-2">
  <h2>Lista de Precios</h2>

  <div class="flex items-center gap-2">
    <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
      <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
      <input matInput placeholder="Buscar" autocomplete="off" (input)="applyFilter($event.target.value)" />
    </mat-form-field>
    <button mat-icon-button color="primary" (click)="openModal(null)" matTooltip="Nuevo registro">
      <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <div class="flex flex-col flex-1 min-h-0" style="height: calc(100vh - 380px)">
    <div class="overflow-y-auto flex-1 dark:bg-gray-900">
      <table mat-table [dataSource]="dataSource" matSort class="w-full mat-elevation-z">
        <ng-container matColumnDef="unit">
          <th mat-header-cell *matHeaderCellDef>U.M.</th>
          <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
            <div><b>{{ element.unit?.code }}</b></div>
            {{ element.unit?.name}}
          </td>
        </ng-container>

        <ng-container matColumnDef="material">
          <th mat-header-cell *matHeaderCellDef>Material</th>
          <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
            <div *ngIf="element.material">
              <div *ngIf="getCode(element.material) as code">
                <b>{{ code }}</b>
              </div>
            </div>
            {{ element.material?.name}}
          </td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Precio</th>
          <td mat-cell *matCellDef="let element">
            {{ element.price }}
          </td>
        </ng-container>

        <ng-container matColumnDef="scalePrices">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Escalas</th>
          <td mat-cell *matCellDef="let element" class="px-6 text-left">
            <mat-icon color="primary" matBadge="{{element?.scalePrices?.length || 0}}" matBadgeColor="accent"
              matBadgeSize="small" aria-hidden="false">local_atm
            </mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
          <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
            <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu">
              <button mat-menu-item (click)="openModal(element, 'P')">
                <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                <span>Editar Registro</span>
              </button>
              <button mat-menu-item (click)="openDeleteDialog(element, 'P')">
                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                <span>Eliminar Registro</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no
        hay
        registros para mostrar.
      </div>
    </div>

    <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
      <mat-paginator [length]="dataSource.data.length" [pageSize]="50" [pageSizeOptions]="[100, 200, 300, 400]">
      </mat-paginator>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close class="align-right">Aceptar</button>
</mat-dialog-actions>